import { render, staticRenderFns } from "./role-form.vue?vue&type=template&id=f3869ba6"
import script from "./role-form.js?vue&type=script&lang=js&external"
export * from "./role-form.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports